import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, Link, Menu, MenuItem } from '@mui/material';
import { GridColDef, GridRenderCellParams, GridRowModel, GridValueFormatterParams } from '@mui/x-data-grid-pro';
import moment from 'moment';
import config from 'src/data/config';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { usePermissionWrapper } from '../common/hooks/usePermissionWrapper';
import { getPoratlHost } from '../common/hooks/useUtil';

export interface IColumnProps {
  anchorEl: null | HTMLElement;
  onGridLinkClick: (row: GridRowModel) => void;
  gethashedurikey: (params: GridValueFormatterParams<any>) => void;
  handleClick: (e: React.MouseEvent<HTMLElement>, row: GridRowModel) => void;
  handleClose: (optionMenuItem: { id: string; name: string; isEnabled: boolean }) => void;
  artifactList: string[];
}
export const useColumns = (props: IColumnProps) => {
  const { anchorEl, onGridLinkClick, gethashedurikey, handleClick, handleClose, artifactList } = props;
  const open = Boolean(anchorEl);
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const optionsMenu = config.isfBinderViewer?.optionsMenu;
  const { checkPermission, checkPermissionDocViewLevel } = usePermissionWrapper();
  const appName = 'ISF';
  const columns: GridColDef[] = [
    {
      field: 'isf_document_name',
      headerName: 'Document Name',
      width: 250,
      valueFormatter: params =>
        `=HYPERLINK("${getPoratlHost()}/?application=${appName}&key=${gethashedurikey(params)}", "${params.value}")`,
      renderCell: (params: any) =>
        checkPermission('view_document_details') ? (
          <Link onClick={() => onGridLinkClick(params.row)}>{params.value!.toString()}</Link>
        ) : (
          params.value!.toString()
        )
    },
    {
      field: 'isf_artifact_name',
      headerName: 'Artifact Name',
      width: 200,
      type: 'singleSelect',
      valueOptions: artifactList
    },
    {
      field: 'isf_doc_version_number',
      headerName: 'Version (latest version)',
      width: 100,
      type: 'number',
      align: 'left'
    },
    {
      field: 'created_on',
      headerName: 'Created on',
      width: 150,
      type: 'date',
      valueGetter: params => {
        if (params.value !== null) {
          return moment(new Date(params.value)).format(userPreferedDateFormat.toUpperCase());
        }
        return;
      }
    },
    {
      field: 'isf_doc_status',
      headerName: 'Status ',
      width: 160,
      type: 'singleSelect',
      valueOptions: ['Uploaded', 'Ready for approval', 'Approved', 'Rejected', 'Expected', 'Sent To TMF']
    },
    {
      field: 'Actions',
      type: 'actions',
      width: 20,
      hideable: false,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <IconButton
              aria-label="more"
              id={params?.row?.fileId}
              aria-controls={open ? 'action-menu' : undefined}
              aria-expanded={open ? 'true' : undefined}
              aria-haspopup="true"
              onClick={(e: any) => handleClick(e, params.row)}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="action-menu"
              MenuListProps={{
                'aria-labelledby': 'moreAction-button'
              }}
              anchorEl={anchorEl}
              open={params?.row?.fileId === anchorEl?.id}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }}
              className="listmenu-3dots"
            >
              {optionsMenu?.map((optionMenuItem: any, index: number) => {
                if (optionMenuItem.id === 'sendAsLink') {
                  if (optionMenuItem.isEnabled) {
                    return (
                      <MenuItem key={index} onClick={() => handleClose(optionMenuItem)} disableRipple>
                        {optionMenuItem.name}
                      </MenuItem>
                    );
                  }
                } else if (optionMenuItem.id === 'auditTrail') {
                  if (optionMenuItem.isEnabled) {
                    return (
                      <MenuItem key={index} onClick={() => handleClose(optionMenuItem)} disableRipple>
                        {optionMenuItem.name}
                      </MenuItem>
                    );
                  }
                } else if (optionMenuItem.id === 'versionHistory') {
                  if (optionMenuItem.isEnabled) {
                    return (
                      <MenuItem key={index} onClick={() => handleClose(optionMenuItem)} disableRipple>
                        {optionMenuItem.name}
                      </MenuItem>
                    );
                  }
                } else if (optionMenuItem.id === 'addNewVersion') {
                  return (
                    <MenuItem
                      disabled={!checkPermission('uploaded_document')}
                      onClick={() => handleClose(optionMenuItem)}
                      key={index}
                      disableRipple
                    >
                      {optionMenuItem.name}
                    </MenuItem>
                  );
                } else if (optionMenuItem.isEnabled) {
                  return (
                    <MenuItem key={index} onClick={() => handleClose(optionMenuItem)} disableRipple>
                      {optionMenuItem.name}
                    </MenuItem>
                  );
                }
              })}
            </Menu>
          </div>
        );
      }
    }
  ];

  return { columns };
};
